<template>
  <v-container grid-list-xl>
    <v-form ref="form" lazy-validation>
      <v-layout wrap>
        <v-flex xs12 sm12 md6>
          <v-text-field
            :label="$t('message.tasas.periodo.nombre')"
            placeholder="Nombre"
            v-model="form.nombre"
            readonly
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md3>
          <DatePicker
            id="periodoConsumoPeriodo"
            v-model="form.periodoConsumo"
            placeholder="dd/mm/yyyy"
            :pickerOptions="allowedDays"
            :label="$t('message.tasas.periodo.periodo')"
            :rules="rules.periodo"
            :error-messages="periodoErrorMessage"
          ></DatePicker>
        </v-flex>
        <v-flex xs12 sm6 md3>
          <Numeric
            id="preciofacturacionPeriodo"
            v-model="form.facturacion"
            currency="€"
            :label="$tc('message.tasas.periodo.facturacion', 1)"
          ></Numeric>
        </v-flex>
      </v-layout>
      <v-layout align-center justify-end row fill-height>
        <Boton id="btnCancelar" tipo="warning" :onclick="onCancel">{{
          $t('message.comun.cancelar')
        }}</Boton>
        <Boton id="btnGuardar" tipo="warning" :onclick="onSubmit">{{
          $t('message.comun.guardar')
        }}</Boton>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
import { getVigenciaBaseCotizacionEmpresa } from '@/api/empresas';
import { Numeric, DatePicker, Boton } from '@/components';
import { mapActions } from 'vuex';
import logger from '@/utils/logger';
import moment from 'moment';
export default {
  name: 'PeriodoConsumo',
  props: {
    model: {
      type: Object,
      required: true
    },
    mesFacturacion: {
      type: Date,
      required: true
    }
  },
  components: {
    Numeric,
    DatePicker,
    Boton
  },
  created() {
    Object.assign(this.form, this.model);
  },
  data() {
    return {
      form: {
        id: '',
        tipoEmpresa: '',
        idBaseCo: '',
        idCuota: null,
        tipoTasa: '',
        nombre: '',
        periodoConsumo: null,
        facturacion: null,
        baseImponible: 0,
        tipo: '',
        selected: false
      },
      rules: {
        periodo: [() => this.periodoConsumoChangeHandler()]
      },
      periodoErrorMessage: []
    };
  },
  methods: {
    ...mapActions(['setLoading']),
    allowedDays(val) {
      return (
        moment(val).toDate() <=
        moment(this.mesFacturacion)
          .endOf('month')
          .toDate()
      );
    },
    onSubmit() {
      if (this.periodoErrorMessage.length == 0) {
        this.form.selected = true;
        this.form.baseImponible = this.form.facturacion;
        // Calculamos la cuota tributaria
        this.form.cuotaTributaria = Math.round10(
          (this.form.baseImponible * this.form.tipo) / 100,
          -2
        );
        this.$emit('modify', this.form);
      }
    },
    onCancel() {
      this.form = {};
      this.$emit('cancel');
    },
    periodoConsumoChangeHandler() {
      this.form.tipo = '';

      // Campo obligatorio
      if (this.form.periodoConsumo == null || this.form.periodoConsumo === '') {
        this.periodoErrorMessage = ['campo obligatorio'];
        return true;
      }
      // Validamos la vigencia de la fecha
      let payload = {
        id: this.form.id,
        idEmpresa: this.$store.getters.empresaSelected.idempres,
        idCuota: this.form.idCuota,
        idBaseCotizacion: this.form.idBaseCo,
        fechaConsumo: moment(this.form.periodoConsumo).valueOf()
      };
      this.setLoading(true);
      var self = this;
      getVigenciaBaseCotizacionEmpresa(payload).then(
        response => {
          self.form.tipo = response.data.nuporcen;
          self.periodoErrorMessage = [];
          this.setLoading(false);
        },
        error => {
          if (error.response && error.response.status === 404) {
            // Fecha no vigente
            this.periodoErrorMessage = [error.response.data.detail];
          } else {
            logger.print(error);
            this.periodoErrorMessage = ['No se ha podido verificar la validez de la fecha'];
          }
          this.setLoading(false);
        }
      );

      return true;
    }
  }
};
</script>
